import { supabase } from '../config/supabase';

export type VehicleAvailabilityStatus =
  | 'available'
  | 'busy'
  | 'maintenance'
  | 'pending_decision';

export interface VehicleAvailabilityRow {
  vehicle_id: string;
  fleet_number: string;
  model: string;
  capacity: number;
  fleet_operator_id: string;
  operator_name: string;
  vehicle_status: string;
  availability_status: VehicleAvailabilityStatus;
  busy_from: string | null;
  busy_until: string | null;
  trip_count: number;
}

export interface VehicleAvailabilitySummary {
  available: number;
  busy: number;
  maintenance: number;
  pending_decision: number;
  total: number;
}

export async function fetchVehicleAvailability(params: {
  date: string;
  windowStart?: string | null;
  windowEnd?: string | null;
}): Promise<VehicleAvailabilityRow[]> {
  const { data, error } = await supabase.rpc('vehicle_availability_status', {
    p_date: params.date,
    p_window_start: params.windowStart ?? null,
    p_window_end: params.windowEnd ?? null,
  });

  if (error) throw new Error(error.message);
  return (data ?? []) as VehicleAvailabilityRow[];
}

export function summarizeVehicleAvailability(
  rows: VehicleAvailabilityRow[]
): VehicleAvailabilitySummary {
  const summary: VehicleAvailabilitySummary = {
    available: 0,
    busy: 0,
    maintenance: 0,
    pending_decision: 0,
    total: rows.length,
  };

  for (const row of rows) {
    summary[row.availability_status] += 1;
  }

  return summary;
}

export function formatAvailabilityStatusLabel(status: VehicleAvailabilityStatus): string {
  switch (status) {
    case 'available':
      return 'Available';
    case 'busy':
      return 'Busy';
    case 'maintenance':
      return 'Maintenance';
    case 'pending_decision':
      return 'Pending owner';
    default:
      return status;
  }
}

export function getAvailabilityStatusColor(status: VehicleAvailabilityStatus): string {
  switch (status) {
    case 'available':
      return 'success';
    case 'busy':
      return 'processing';
    case 'maintenance':
      return 'warning';
    case 'pending_decision':
      return 'gold';
    default:
      return 'default';
  }
}
